
import { useRef } from "react";
import Crop from "./crop";
import Flip from "./flip";
import Resize from "./resize";
import Rotate from "./rotate";

import {
  warningText,
  validateDimention,
} from "../../../../helpers/validatorHelper";

const Control = ({
  service,
  image,
  isFlipVertical,
  isFlipHorizontal,
  cropIsSaveProportions,
  cropValidation,
  imageHeight,
  imageWidth,
  cropDimensions,
  analytics,
  dispatch,
  setFlipVertical,
  setDimensionsetChanged,
  setFlipHorizontal,
  cropSetIsSaveProportions,
  cropSetDimensions,
  previewClearPosition,
  canvasRotationAngle,
  canvasDimensionWidth,
  canvasDimensionHeight,
  canvasSetRotationAngle,
  canvasSetDimension,
  resizeIsSaveProportion,
  resizeCanvasFormat,
  warningWidth,
  warningHeight,
  setWarningWidth,
  setWarningHeight,
  resizeIsOpenSelect,
  resizeSetOpenSelect,
  setChanged,
  resizeSetSaveProportions,
  resizeSetFormat,
}) => {
  
  //Crop
  const cropInputWidth = useRef<HTMLInputElement>(null);
  const cropInputHeight = useRef<HTMLInputElement>(null);

  const cropInputChangeHandler = () => {
    dispatch(setChanged());
    cropSetDimensions(
      +cropInputWidth.current.value,
      +cropInputHeight.current.value
    );
  };

  const cropIsSaveProportionsHandler = (cropIsSaveProportions) => {
    cropSetIsSaveProportions(!cropIsSaveProportions);
    analytics.sendChangeSaveProporsion(!cropIsSaveProportions);
  };
  //End Crop

  //Flip
  const flipHorizontalChangeHandler = (isFlipHorizontal) => {
    dispatch(setFlipHorizontal(isFlipHorizontal));
    dispatch(setChanged());
    analytics.sendClickHorizontal();
  };

  const flipVericalChangeHandler = (isFlipVertical) => {
    dispatch(setFlipVertical(isFlipVertical));
    dispatch(setChanged());
    analytics.sendClickVertical();
  };
  //End Flip

  //Rotate

  const rotateChangeHandler = (
    isRight,
    canvasRotationAngle,
    canvasWidth,
    canvasHeight
  ) => {
    dispatch(
      canvasSetRotationAngle(
        isRight ? canvasRotationAngle + 90 : canvasRotationAngle - 90
      )
    );
    dispatch(setChanged());
    dispatch(canvasSetDimension(canvasWidth, canvasHeight));
    dispatch(previewClearPosition());

    isRight
      ? analytics.sendClickRotateRight()
      : analytics.sendClickRotateLeft();
  };

  //End Rotate

  //Resize the

  const resizeInputChangeHandler = (
    e,
    modifiedProps: string,
    isSaveProperties: boolean,
    imageWidth,
    imageHeight,
    canvasWidth,
    canvasHeight,
    setWarningWidth
  ) => {
    dispatch(setChanged());
    setWarningWidth("");
    setWarningHeight("");

    const inputDimensionProps: { width: number; height: number } = {
      width:
        modifiedProps === "width" && !isNaN(parseInt(e.target.value))
          ? parseInt(e.target.value)
          : canvasWidth,
      height:
        modifiedProps === "height" && !isNaN(parseInt(e.target.value))
          ? parseInt(e.target.value)
          : canvasHeight,
    };

    if (isSaveProperties && modifiedProps === "width") {
      inputDimensionProps.height =
        imageHeight * (inputDimensionProps.width / imageWidth);
    }

    if (isSaveProperties && modifiedProps === "height") {
      inputDimensionProps.width =
        imageWidth * (inputDimensionProps.height / imageHeight);
    }

    const validatePropWidth = validateDimention(
      "width",
      inputDimensionProps.width
    );
    const validatePropHeight = validateDimention(
      "height",
      inputDimensionProps.height
    );

    if (validatePropWidth.isValid && validatePropHeight.isValid) {
      if (
        canvasWidth !== inputDimensionProps.width ||
        canvasHeight !== inputDimensionProps.height
      ) {
        dispatch(
          canvasSetDimension(
            Math.round(inputDimensionProps.height),
            Math.round(inputDimensionProps.width)
          )
        );
      }
      analytics.sendChangeDimensiom(
        inputDimensionProps.width,
        inputDimensionProps.height,
        modifiedProps
      );
    } else {
      setWarningWidth(!validatePropWidth.isValid ? validatePropWidth.type : "");
      setWarningHeight(
        !validatePropHeight.isValid ? validatePropHeight.type : ""
      );
      analytics.sendErrorChangeDimensiom(
        inputDimensionProps.width,
        inputDimensionProps.height,
        modifiedProps
      );
    }
  };

  const resizeClickOptionHandler = (
    type,
    resizeIsOpenSelect,
    resizeSetOpenSelect
  ) => {
    dispatch(resizeSetFormat(type));
    dispatch(setChanged());
    resizeSetOpenSelect(!resizeIsOpenSelect);
    analytics.sendChangeSelectFormat(type);
  };

  const resizeSetSaveProportionsHandler = (isSave) => {
    dispatch(resizeSetSaveProportions(!isSave));
  };

  //End Resize

  return (
    <>
      <Resize
        isShow={service === "resizer"}
        isAddedImage={!!image}
        resizeIsOpenSelect={resizeIsOpenSelect}
        resizeSetOpenSelect={resizeSetOpenSelect}
        resizeIsSaveProportion={resizeIsSaveProportion}
        resizeSetSaveProportions={resizeSetSaveProportionsHandler}
        resizeFormat={resizeCanvasFormat}
        imageHeight={imageHeight}
        imageWidth={imageWidth}
        warningText={warningText}
        warningWidth={warningWidth}
        warningHeight={warningHeight}
        canvasWidth={canvasDimensionWidth}
        canvasHeight={canvasDimensionHeight}
        resizeClickOptionHandler={resizeClickOptionHandler}
        resizeInputChangeHandler={resizeInputChangeHandler}
        inputWidth={undefined}
        inputHeight={undefined}
        inputWidthValue={0}
        inputHeightValue={0}
        setWarningWidth={setWarningWidth}
      />

      <Rotate
        isShow={service === "rotator"}
        isAddedImage={!!image}
        rotateChangeHandler={rotateChangeHandler}
        canvasRotationAngle={canvasRotationAngle}
        canvasDimensionWidth={canvasDimensionWidth}
        canvasDimensionHeight={canvasDimensionHeight}
      />
      <Flip
        isDisabled={!!image}
        isShow={service === "flipper"}
        isFlipVertical={isFlipVertical}
        isFlipHorizontal={isFlipHorizontal}
        flipHorizontalChangeHandler={flipHorizontalChangeHandler}
        flipVericalChangeHandler={flipVericalChangeHandler}
      />

      <Crop
        isShow={service === "cropper"}
        isAddedImage={!!image}
        cropWidth={
          cropDimensions.width ? cropDimensions.width : Math.round(imageWidth * 0.9)
        }
        cropHeight={
          cropDimensions.height ? cropDimensions.height : Math.round(imageHeight * 0.9)
        }
        cropIsSaveProportions={cropIsSaveProportions}
        cropError={cropValidation}
        cropInputChangeHandler={cropInputChangeHandler}
        cropInputWidth={cropInputWidth}
        cropInputHeight={cropInputHeight}
        cropIsSaveProportionsHandler={cropIsSaveProportionsHandler}
      />
    </>
  );
};

export default Control;
